module.exports = __webpack_public_path__ + "static/media/yungSeries.4e06336d.gif";